import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import printVoucherCargo from '../../../../../utils/printers/CargoVoucher';
import { flagPrintCargo } from '../../../../../actions';

const PrintCargoVoucherButton = ({ voucher, dispatchFlagPrintCargo, print, printOnMount }) => {
  const printVoucher = () => {
    dispatchFlagPrintCargo(true);
    printVoucherCargo(typeof voucher === 'object' ? voucher : voucher.toJSON());
    setTimeout(()=>{
      dispatchFlagPrintCargo(false)
    }, 4000)
  };

  return (
    <Button color="light" className="border" onClick={printVoucher} disabled={print || printOnMount}>
      <i className={`fa ${print || printOnMount ? "fa-spinner" : "fa-print"}`} /> Imprimir
    </Button>
  );
};

PrintCargoVoucherButton.propTypes = {
  voucher: PropTypes.oneOfType([PropTypes.instanceOf(Map), PropTypes.object])
    .isRequired,
 dispatchFlagPrintCargo: PropTypes.func.isRequired,
  print: PropTypes.bool.isRequired,
  printOnMount: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ CargoUnit }) => ({
  print: CargoUnit.Cargo.getIn(['current', 'print']),
  printOnMount: CargoUnit.Cargo.getIn(['current', 'printOnMount']),
});

const mapDispatchToProps = {
  dispatchFlagPrintCargo: flagPrintCargo,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintCargoVoucherButton);
